import type { FormIndexEntry } from "@/utils/ranapFormRegistry";
export type { FormIndexEntry };

export const MPP_TAB = "tab-mpp";

const MPP_FORM: [string, string, string] = [
	MPP_TAB,
	"MPP (Manajer Pelayanan Pasien)",
	"mpp manajer pelayanan pasien case manager skrining perencanaan implementasi",
];

const RM_FORMS: Array<[string, string, string?]> = [
	["tab-soap", "CPPT"],
	["tab-assesmen", "Asesmen Awal Ralan"],
	["tab-reghf", "Register HF (Gagal Jantung)"],
	["tab-asesmen-kemo", "Asesmen Pasien Kemoterapi"],
	[
		"tab-rekam-asuhan-hd",
		"Rekam Asuhan Pasien Hemodialisis",
		"hd hemodialisa haemodialisis dialisis cuci darah resep hd heparinisasi monitoring hd dialiser",
	],
	MPP_FORM,
	["tab-monitoring-trombolisis", "Monitoring Trombolisis", "stroke tpa"],
	[
		"tab-skrining-bunuh-diri",
		"Skrining Risiko Bunuh Diri",
		"bunuh diri melukai diri sendiri suicide self harm hemodialisa kemoterapi",
	],
	[
		"tab-asesmen-geriatri",
		"Asesmen Geriatri Komprehensif (CGA)",
		"geriatri lansia cga barthel adl mna nutrisi risiko jatuh ontario polifarmasi kognitif",
	],
	[
		"tab-asesmen-gigi-mulut",
		"Asesmen Awal Gigi & Rongga Mulut",
		// Asesmen Dental Khusus dirender di tab yang sama (di bawah divider).
		"dental khusus odontogram ohis ohi-s foto klinis gigi",
	],
	["tab-prmrj", "Profil Ringkas Medis Ralan (PRMRJ)"],
	["tab-catatan-edukasi", "Catatan Edukasi"],
	["tab-mcu", "MCU (Medical Check-Up)"],
	["tab-laporan-operasi", "Laporan Operasi"],
	["tab-catatan-pemberian-obat", "Catatan Pemberian Obat (CPO/MAR)"],
	["tab-askep", "Asuhan Keperawatan"],
	["tab-nihss", "Penilaian NIHSS", "stroke skala defisit neurologis"],
	["tab-transfer-internal", "Transfer Internal"],
	[
		"tab-kriteria-iri",
		"Kriteria Masuk/Keluar IRI",
		"icu hcu iccu intensif kriteria masuk keluar",
	],
	[
		"tab-bundle-ppi",
		"Bundle PPI",
		"vap isk iad ido hais ventilator kateter urin infeksi daerah operasi aliran darah pencegahan kepatuhan",
	],
	[
		"tab-penggunaan-alat-reuse",
		"Penggunaan Alat Reuse",
		"alat reuse single-use sterilisasi ppi cssd batas pakai",
	],
	[
		"tab-asesmen-okupasi-terapi",
		"Assesment Awal Okupasi Terapi",
		"rehab medik rehabilitasi okupasi ADL performance komponen",
	],
	[
		"tab-asesmen-terapi-wicara",
		"Assesment Awal Terapi Wicara",
		"rehab medik rehabilitasi wicara bahasa bicara suara menelan disfagia gagap",
	],
	[
		"tab-asesmen-fisioterapi",
		"Assesment Awal Fisioterapi",
		"rehab medik rehabilitasi fisioterapi nyeri NRS ROM MMT ADL mobilitas intervensi SWD MWD TENS exercise",
	],
];

// Sub-tab level di dalam "Asesmen Awal Ralan" (CardSubAssesmen). subTab =
// v-model tab dalamnya; form yang hanya berupa panel (Skrining) diarahkan ke
// sub-tab induknya. [subTab, label, keywords?].
const ASESMEN_SUB_FORMS: Array<[string, string, string?]> = [
	["tab-perawat", "Asesmen Awal Ralan — Keperawatan"],
	["tab-dokter", "Asesmen Awal Ralan — Medis"],
	["tab-perawat", "Riwayat Perkawinan", "pernikahan status kawin pasangan"],
	["tab-skrining", "Skrining Risiko Jatuh"],
	["tab-skrining", "Asesmen Risiko Jatuh"],
	["tab-skrining", "Asesmen Nyeri", "nyeri pain nrs wong baker"],
	["tab-skrining", "Skrining Batuk / TB", "batuk tb tbc tuberkulosis"],
	["tab-skrining", "Skrining Gizi Lanjut", "gizi malnutrisi mst"],
	["tab-skrining", "Skrining Risiko Bunuh Diri", "bunuh diri melukai diri sendiri suicide self harm"],
];

// Resume & Surat Keterangan inner tabs (resumeSuketV2/CardSuket).
// [elemId, label, category] — category must match SUKET_TAB_CATEGORY in that
// component so the deep link can activate the right chip.
const SUKET_FORMS: Array<[string, string, string, string?]> = [
	// Resume & Rawat
	["tab-resume", "Resume Rawat Jalan", "Resume & Rawat"],
	["tab-resume-hemodialisa", "Resume Hemodialisa JKN", "Resume & Rawat"],
	["tab-spri", "Surat Perintah Rawat Inap (SPRI)", "Resume & Rawat"],
	["tab-skdp", "Surat Keterangan DPJP (SKDP)", "Resume & Rawat"],
	// Surat Sehat
	[
		"tab-sehat",
		"Surat Keterangan Dokter",
		"Surat Sehat",
		"surat sehat jasmani keterangan sehat",
	],
	["tab-jiwa", "Surat Keterangan Sehat Jiwa", "Surat Sehat"],
	["tab-napza", "Surat Keterangan Bebas Napza", "Surat Sehat"],
	["tab-sk-mata", "Surat Keterangan Mata", "Surat Sehat"],
	["tab-sk-sehat-paru", "Surat Keterangan Sehat Paru", "Surat Sehat"],
	["tab-sk-sehat-tht", "Surat Keterangan Sehat THT", "Surat Sehat"],
	["tab-sk-dalam", "Surat Keterangan Sehat Dalam", "Surat Sehat"],
	["tab-sk-layak-terbang", "Surat Layak Terbang", "Surat Sehat"],
	["tab-sk-fit-to-work", "Surat Keterangan Fit To Work", "Surat Sehat"],
	["tab-sk-layak-vaksin", "Surat Keterangan Layak Vaksin", "Surat Sehat"],
	["tab-sk-vaksin", "Surat Keterangan Vaksinasi", "Surat Sehat"],
	["tab-sk-tidak-cacat", "Surat Keterangan Tidak Cacat Fisik", "Surat Sehat"],
	["tab-skd-adopsi", "SKD Adopsi", "Surat Sehat"],
	["tab-skbpm", "Surat Keterangan Bebas Penyakit Menular", "Surat Sehat"],
	["tab-sk-disabilitas", "Surat Keterangan Disabilitas", "Surat Sehat"],
	["tab-sk-tato-tindik", "Surat Keterangan Tato Tindik", "Surat Sehat"],
	// Gigi & Mulut
	[
		"tab-sk-pemeriksaan-gigi-mulut",
		"Surat Keterangan Pemeriksaan Gigi & Mulut",
		"Gigi & Mulut",
	],
	["tab-sk-mcu-gigi-mulut", "MCU Gigi & Mulut", "Gigi & Mulut"],
	["tab-sk-klaim-protesa-gigi", "Surat Klaim Protesa Gigi", "Gigi & Mulut"],
	// Surat Khusus
	["tab-diagnosa", "Surat Keterangan Diagnosa", "Surat Khusus"],
	["tab-istirahat", "Surat Keterangan Istirahat", "Surat Khusus"],
	["tab-sk-pulang", "Surat Pemulangan Pasien IGD", "Surat Khusus"],
	["tab-sk-gawat-darurat", "Surat Keterangan Gawat Darurat", "Surat Khusus"],
	[
		"tab-kesanggupan-dirujuk",
		"Surat Pernyataan Kesanggupan Dirujuk",
		"Surat Khusus",
	],
	["tab-sk-kematian", "Surat Keterangan Kematian", "Surat Khusus"],
	[
		"tab-sk-pengawetan-jenazah",
		"Surat Keterangan Pengawetan Jenazah",
		"Surat Khusus",
		"formalin balsem embalming pemulasaran forensik medikolegal",
	],
	["tab-cuti-bersalin", "Surat Keterangan Cuti Bersalin", "Surat Khusus"],
	["tab-visum", "Visum et Repertum", "Surat Khusus"],
	// Persetujuan
	["tab-general-consent", "Persetujuan Umum / General Consent", "Persetujuan"],
	["tab-kronologi", "Surat Pernyataan Kronologi", "Persetujuan"],
	[
		"tab-persetujuan-transfusi-darah",
		"Persetujuan Layanan Darah",
		"Persetujuan",
		"transfusi darah inkompatibel incompatible crossmatch plebotomi flebotomi phlebotomy informed consent bank darah",
	],
	["tab-informed-consent-tindakan", "Informed Consent Tindakan", "Persetujuan"],
	["tab-persetujuan-kb", "Persetujuan Pelayanan KB", "Persetujuan"],
	[
		"tab-permintaan-kerohanian",
		"Permintaan Pelayanan Kerohanian",
		"Persetujuan",
	],
	// Rehab Medik
	["tab-form-klaim-rehab-medik", "Formulir Klaim Rehab Medik", "Rehab Medik"],
	["tab-form-uji-fungsi-kfr", "Formulir Uji Fungsi KFR", "Rehab Medik"],
	// Lainnya
	["tab-form-77", "Form 77 (Pemeriksaan Kesehatan PNS)", "Lainnya"],
	["tab-sk-mcu-cpns-gol3", "MCU CPNS Golongan III (TPK)", "Lainnya"],
	["tab-sk-mcu-umum", "Hasil Medical Check-Up (MCU Umum)", "Lainnya"],
	[
		"tab-sk-mcu-gol-2",
		"MCU Gol. II — Pengujian Kesehatan PNS (DPT)",
		"Lainnya",
	],
	["tab-sk-tindakan-umum", "Surat Keterangan Tindakan", "Lainnya"],
	["tab-sk-tindakan-hd", "Surat Keterangan Tindakan HD", "Lainnya"],
	["tab-sk-kulit-kelamin", "Surat Keterangan Kulit & Kelamin", "Lainnya"],
];

// Rujukan sub-tabs — driven by subTabRujukan in Pemeriksaan.vue. [elemId, label].
const RUJUKAN_FORMS: Array<[string, string]> = [
	["sub-konsul-internal", "Konsul Internal"],
	["sub-rujuk-internal", "Rujuk Internal"],
	["sub-rujukan-keluar", "Rujukan Keluar"],
	["sub-rujukan-hiv", "Rujukan HIV"],
	["sub-rujukan-dots", "Rujukan DOTS / HIV"],
	["sub-rujukan-haji", "Rujukan Balik Haji"],
];

const IGD_RM_FORMS: Array<[string, string, string?]> = [
	[
		"tab-asesmen-awal-gadar",
		"Asesmen Awal Gawat Darurat",
		"igd gadar triase keperawatan survey primer medis",
	],
	[
		"tab-askep-gadar",
		"Asuhan Keperawatan",
		"askep sdki slki siki diagnosa perencanaan implementasi evaluasi",
	],
	[
		"tab-trombolisis",
		"Screening Trombolisis",
		"stroke tpa alteplase rtpa skrining trombolitik ceklist kontraindikasi",
	],
	["tab-nihss", "Penilaian NIHSS", "stroke skala defisit neurologis"],
	[
		"tab-skrining-bunuh-diri",
		"Skrining Risiko Bunuh Diri",
		"bunuh diri melukai diri sendiri suicide self harm",
	],
	["tab-cppt", "CPPT", "catatan perkembangan pasien terintegrasi soap"],
	MPP_FORM,
	["tab-laporan-operasi", "Laporan Operasi"],
	["tab-catatan-pemberian-obat", "Catatan Pemberian Obat (CPO/MAR)"],
	["tab-catatan-edukasi", "Catatan Edukasi"],
	["tab-transfer-internal", "Transfer Internal", "pindah ruang serah terima"],
	[
		"tab-monitoring-kritis",
		"Monitoring Pasien IGD",
		"monitoring kritis ttv intervensi medikasi",
	],
	["tab-monitoring-trombolisis", "Monitoring Trombolisis", "stroke tpa"],
	[
		"tab-kriteria-iri",
		"Kriteria Masuk/Keluar IRI",
		"icu hcu iccu intensif kriteria masuk keluar",
	],
	["tab-partograf", "Partograf", "persalinan kala who catatan persalinan"],
	[
		"tab-observasi-kebidanan",
		"Observasi Kebidanan",
		"bishop score vt his djj pembukaan",
	],
	[
		"tab-bundle-ppi",
		"Bundle PPI",
		"vap isk iad ido hais ventilator kateter urin infeksi daerah operasi aliran darah pencegahan kepatuhan",
	],
	[
		"tab-penggunaan-alat-reuse",
		"Penggunaan Alat Reuse",
		"alat reuse single-use sterilisasi ppi cssd batas pakai",
	],
];

const IGD_ASESMEN_SUB_FORMS: Array<[string, string, string?]> = [
	[
		"tab-perawat",
		"Asesmen Awal Gadar — Keperawatan",
		"status pernikahan riwayat perkawinan",
	],
	[
		"tab-perawat",
		"Asuhan Keperawatan Gawat Darurat",
		"askep gadar igd diagnosa intervensi",
	],
	[
		"tab-perawat",
		"Asuhan Kebidanan Gawat Darurat",
		"askeb gadar igd bidan",
	],
	["tab-survey", "Asesmen Awal Gadar — Survey Primer", "abcde airway triase"],
	["tab-dokter", "Asesmen Awal Gadar — Survey Sekunder", "medis dokter dpjp anamnesis pemeriksaan fisik diagnosa kerja"],
];

const IGD_RUJUKAN_FORMS: Array<[string, string, string?]> = [
	["", "Surat Konsul", "konsul konsultasi spesialis"],
	["", "Surat Rujukan Ranap / Rujukan Keluar", "rujuk rujukan keluar rs lain"],
	["", "Surat Jawaban Rujukan", "balasan jawaban rujukan masuk"],
];

const SHARED_HOST_FORMS: FormIndexEntry[] = [
	{
		label: "Order Penunjang (Lab / Radiologi)",
		topTab: "tab-penunjang",
		group: "Penunjang",
		elemId: "lab-radiologi",
		keywords: "lab laboratorium radiologi rontgen ro penunjang",
	},
	{
		label: "Penunjang Lain",
		topTab: "tab-penunjang",
		group: "Penunjang",
		elemId: "penunjang-lain",
		keywords: "penunjang",
	},
	{
		label: "Riwayat Hasil Lab (Lintas Kunjungan)",
		topTab: "tab-penunjang",
		group: "Penunjang",
		elemId: "riwayat-hasil-lab",
		keywords: "lab laboratorium riwayat lintas kunjungan penunjang",
	},
	{
		label: "Pengantar Kultur & Tes Kepekaan Antibiotika (Mikrobiologi)",
		topTab: "tab-penunjang",
		group: "Penunjang › Lainnya",
		elemId: "lainnya-kultur-antibiotika",
		keywords: "kultur mikrobiologi antibiotika",
	},
	{
		label: "Formulir Hasil Pemeriksaan USG",
		topTab: "tab-penunjang",
		group: "Penunjang › Lainnya",
		elemId: "lainnya-hasil-usg",
		keywords: "usg",
	},
	{
		label: "Permintaan Pemeriksaan Patologi Anatomi",
		topTab: "tab-penunjang",
		group: "Penunjang › Lainnya",
		elemId: "lainnya-patologi-anatomi",
		keywords: "patologi anatomi pa",
	},
	{
		label: "Resep Obat",
		topTab: "tab-resep",
		group: "Resep Obat",
		keywords: "resep obat racikan bmhp lembar permintaan retur",
	},
	{
		label: "Input Billing Pelayanan",
		topTab: "tab-pelayanan",
		group: "Billing",
		keywords: "billing tagihan tarif tindakan medik pelayanan",
	},
	{
		label: "Permintaan Komponen Darah",
		topTab: "tab-penunjang",
		group: "Penunjang › Order Darah",
		elemId: "order-darah-komponen",
		subTab: "card-permintaan-komponen-darah",
		keywords:
			"transfusi darah utd bdrs bank darah prc wb whole blood trombosit tc prp ffp cryo wrc buffy kolf golongan rhesus komponen",
	},
	{
		label: "Permintaan Komponen Darah Lainnya (Rujukan)",
		topTab: "tab-penunjang",
		group: "Penunjang › Order Darah",
		elemId: "order-darah-komponen-rujukan",
		subTab: "card-komponen-rujukan",
		keywords:
			"rujukan komponen darah luar pmi utd bank darah kirim lainnya",
	},
	{
		label: "Pemeriksaan Golongan Darah Metode Tabung",
		topTab: "tab-penunjang",
		group: "Penunjang › Order Darah",
		elemId: "order-darah-golongan-tabung",
		subTab: "card-golongan-tabung",
		keywords:
			"golongan darah abo rhesus metode tabung cell grouping serum grouping bank darah",
	},
	{
		label: "Pemeriksaan Coomb's Test",
		topTab: "tab-penunjang",
		group: "Penunjang › Order Darah",
		elemId: "order-darah-coombs-test",
		subTab: "card-coombs-test",
		keywords:
			"coombs coomb comb direct indirect dct ict antiglobulin aiha bank darah",
	},
	{
		label: "Pemeriksaan Darah Lainnya (Rujukan)",
		topTab: "tab-penunjang",
		group: "Penunjang › Order Darah",
		elemId: "order-darah-darah-lainnya-rujukan",
		subTab: "card-darah-lainnya-rujukan",
		keywords:
			"rujukan pemeriksaan darah ab dweak wrc leukodepletet bank darah lainnya",
	},
	{
		label: "Permintaan Tindakan Plebotomi Terapi",
		topTab: "tab-penunjang",
		group: "Penunjang › Order Darah",
		elemId: "order-darah-plebotomi-terapi",
		subTab: "card-plebotomi-terapi",
		keywords:
			"plebotomi flebotomi phlebotomy terapi venaseksi polisitemia hemokromatosis bank darah",
	},
	{
		label: "Hasil Pemeriksaan Bank Darah",
		topTab: "tab-penunjang",
		group: "Penunjang › Order Darah",
		elemId: "order-darah-hasil-bank-darah",
		subTab: "card-hasil-bank-darah",
		keywords:
			"hasil bank darah bdrs crossmatch cross match uji cocok serasi mayor minor auto kontrol coombs dct ict kompatibel inkompatibel gel test odak golongan rhesus kantong persetujuan transfusi darah inkompatibel informed consent golongan darah metode tabung cell grouping serum grouping anti a anti b sel a sel b sel o anti d b alb positif negatif pemeriksaan darah lainnya rujukan sab dweak wrc leukodepletet komponen darah lainnya rujukan tempat rujukan plebotomi terapi",
	},
	{
		label: "Pembatalan Komponen Darah",
		topTab: "tab-penunjang",
		group: "Penunjang › Order Darah",
		elemId: "order-darah-pembatalan-komponen",
		subTab: "card-pembatalan-komponen-darah",
		keywords:
			"pembatalan batal kantong darah komponen darah dibatalkan tidak jadi transfusi pasien pulang meninggal bank darah bdrs",
	},
];

const SUKET_INDEX: FormIndexEntry[] = SUKET_FORMS.map(
	([elemId, label, category, keywords]) => ({
		label,
		topTab: "tab-suket",
		group: "Surat Keterangan › " + category,
		elemId,
		category,
		keywords,
	}),
);

/** Full cross-tab search index for the Ralan/IGD exam page. */
export const RALAN_FORM_INDEX: FormIndexEntry[] = [
	...RM_FORMS.map(([elemId, label, keywords]) => ({
		label,
		topTab: "tab-assesmen",
		group: "Rekam Medis",
		elemId,
		keywords,
	})),
	...ASESMEN_SUB_FORMS.map(([subTab, label, keywords]) => ({
		label,
		topTab: "tab-assesmen",
		group: "Rekam Medis › Asesmen Awal Ralan",
		elemId: "tab-assesmen",
		subTab,
		keywords,
	})),
	...SUKET_INDEX,
	...RUJUKAN_FORMS.map(([elemId, label]) => ({
		label,
		topTab: "tab-konsul",
		group: "Rujukan",
		elemId,
	})),
	...SHARED_HOST_FORMS,
	{
		label: "Dokumentasi Kelainan Kulit",
		topTab: "tab-penunjang",
		group: "Penunjang › Lainnya",
		elemId: "lainnya-kelainan-kulit",
		keywords: "kelainan kulit",
	},
];

export const IGD_FORM_INDEX: FormIndexEntry[] = [
	...IGD_RM_FORMS.map(([elemId, label, keywords]) => ({
		label,
		topTab: "tab-assesmen",
		group: "Rekam Medis IGD",
		elemId,
		keywords,
	})),
	...IGD_ASESMEN_SUB_FORMS.map(([subTab, label, keywords]) => ({
		label,
		topTab: "tab-assesmen",
		group: "Rekam Medis IGD › Asesmen Awal Gawat Darurat",
		elemId: "tab-asesmen-awal-gadar",
		subTab,
		keywords,
	})),
	...SUKET_INDEX,
	...IGD_RUJUKAN_FORMS.map(([, label, keywords]) => ({
		label,
		topTab: "tab-konsul",
		group: "Rujukan",
		keywords,
	})),
	...SHARED_HOST_FORMS,
];

export const SKRINING_PASIEN_TAB = "tab-skrining-pasien";

export const PEMERIKSAAN_RINGKAS_RM_TABS: ReadonlyArray<string> = [
	"tab-soap",
	"tab-catatan-edukasi",
	"tab-transfer-internal",
	SKRINING_PASIEN_TAB,
];

export const PEMERIKSAAN_RINGKAS_FORM_INDEX: FormIndexEntry[] = [
	{
		label: "Skrining Pasien",
		topTab: "tab-assesmen",
		group: "Rekam Medis",
		elemId: SKRINING_PASIEN_TAB,
		keywords: "skrining screening",
	},
	...ASESMEN_SUB_FORMS.filter(([subTab]) => subTab === "tab-skrining").map(
		([, label, keywords]) => ({
			label,
			topTab: "tab-assesmen",
			group: "Rekam Medis › Skrining Pasien",
			elemId: SKRINING_PASIEN_TAB,
			keywords,
		}),
	),
	...RM_FORMS.filter(([elemId]) =>
		PEMERIKSAAN_RINGKAS_RM_TABS.includes(elemId),
	).map(([elemId, label, keywords]) => ({
		label,
		topTab: "tab-assesmen",
		group: "Rekam Medis",
		elemId,
		keywords,
	})),
	{
		label: "Rujukan & Konsul",
		topTab: "tab-konsul",
		group: "Rujukan",
		keywords: "konsul konsultasi rujuk rujukan internal keluar jawaban",
	},
	...SHARED_HOST_FORMS.filter((entry) => entry.topTab !== "tab-resep"),
];

export const PEMERIKSAAN_REKAM_MEDIS_RM_TABS: ReadonlyArray<string> = [
	...PEMERIKSAAN_RINGKAS_RM_TABS,
	MPP_TAB,
];

export const PEMERIKSAAN_REKAM_MEDIS_FORM_INDEX: FormIndexEntry[] = [
	...PEMERIKSAAN_RINGKAS_FORM_INDEX,
	{
		label: MPP_FORM[1],
		topTab: "tab-assesmen",
		group: "Rekam Medis",
		elemId: MPP_TAB,
		keywords: MPP_FORM[2],
	},
];

export const PEMANTAUAN_GIZI_TAB = "tab-pemantauan-terapi-gizi";
export const SKRINING_GIZI_LANJUT_TAB = "tab-skrining-gizi-lanjut";

export const PEMERIKSAAN_GIZI_RM_TABS: ReadonlyArray<string> = [
	...PEMERIKSAAN_RINGKAS_RM_TABS,
	PEMANTAUAN_GIZI_TAB,
	SKRINING_GIZI_LANJUT_TAB,
];

export const PEMERIKSAAN_GIZI_FORM_INDEX: FormIndexEntry[] = [
	...PEMERIKSAAN_RINGKAS_FORM_INDEX.map((entry) =>
		entry.label === "Skrining Gizi Lanjut"
			? { ...entry, group: "Rekam Medis", elemId: SKRINING_GIZI_LANJUT_TAB }
			: entry,
	),
	{
		label: "Pemantauan Pemberian Terapi Gizi",
		topTab: "tab-assesmen",
		group: "Rekam Medis",
		elemId: PEMANTAUAN_GIZI_TAB,
		keywords: "pemantauan gizi terapi diet asupan energi protein",
	},
];
